export default "__VITE_ASSET__ca1dbacf__"